import { useRef, useState } from "react";
import {
  dateFormmaterNoTime,
  fixTimezoneOffset,
  formatTime,
} from "global/helpers";
import { useQuery } from "react-query";
import AgGrid from "elements/AgGrid";
import { getUserAccounts } from "pages/UserManagement/UserManagement.services";
import { FormProvider, useForm } from "react-hook-form";
import Lookup from "elements/Lookup";
import SelectionModal from "components/SelectionModal/SelectionModal";
import DatePicker from "react-datepicker";
import { getTimeSheet } from "./PayrollServices/payrollServices";
import * as colDefs from "../../constants/colDefs";
import { getUserProfile } from "pages/User/userServices";

const Timesheet = () => {
  const firstSet = useRef(true);

  const getFirstDayOfWeek = (d) => {
    const date = new Date(d);
    const day = date.getDay();

    const diff = date.getDate() - day + (day === 0 ? -6 : 1);

    return new Date(date.setDate(diff));
  };

  const currentDate = new Date();
  const lastWeek = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate() - 7
  );
  let initialDate = getFirstDayOfWeek(lastWeek);
  const lastDay = new Date(initialDate);
  let lastDate = new Date(lastDay.setDate(lastDay.getDate() + 6));
  const [filters, setFilters] = useState<any>({
    startDate: initialDate,
    endDate: lastDate,
  });
  const [openSelection, setOpenSelection] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [startDate, setStartDate] = useState<Date>(initialDate);
  const [endDate, setEndDate] = useState<Date>(lastDate);

  const { data: userAccounts } = useQuery("user_accounts", getUserAccounts);

  const { data: userProfile } = useQuery("userProfile", getUserProfile);

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const { data } = useQuery(
    ["timesheet", filters],
    () => getTimeSheet(filters),
    {
      onSuccess(data) {
        if (firstSet.current) {
          let start = data?.data?.startDate;
          onStartDateChange(start);
          let end = data?.data?.endDate;
          onEndDateChange(end);
          firstSet.current = false;
        }
      },
    }
  );

  const userColumns = [
    {
      minWidth: 250,
      headerName: "Employee Id",
      field: "employeeId",
    },
    {
      headerName: "Employee Name",
      field: "employeeId",
      valueGetter: (params) => {
        return params.data.firstName + " " + params.data.lastName;
      },
    },
    {
      headerName: "Email",
      field: "email",
      minWidth: 250,
    },
    {
      maxWidth: colDefs.smWidth,
      headerName: "Role",
      field: "roles",
      cellRendererFramework: (params) =>
        params.value.length > 1 ? "Multiple" : params.value,
    },
    // {
    //     headerName: "Cell No",
    //     field: "mobileNumber",
    //     valueGetter: (params) => { return params.data.mobileNumber ? params.data.mobileNumber.toString().replace(/(\d{3})\D?(\d{4})\D?(\d{4})/, "$1 $2 $3") : "" },
    // },
    {
      maxWidth: colDefs.sm_mWidth,

      headerName: "Hub",
      field: "hubs",
      valueGetter: (params) => {
        return params.data.roles[0] === "Admin"
          ? "All"
          : params.data.hubs.length > 1
          ? params.data.hubs?.map((hub) => {
              return hub + " ";
            })
          : params.data.hubs;
      },
    },
    {
      maxWidth: colDefs.booleanWidth,

      headerName: "Status",
      field: "isActive",
      cellRendererFramework: (params) =>
        params.data.isActive ? (
          <div className="active-status">active</div>
        ) : (
          <div className="disabled-status">disabled</div>
        ),
    },
    {
      headerName: "Date Added",
      field: "dateAdded",
      cellRendererFramework: (params) =>
        dateFormmaterNoTime(params.data.dateAdded),
    },
  ];

  const columns = [
    {
      field: "employeeId",
      headerName: "Employee Id",
    },
    {
      field: "employeeName",
      headerName: "Employee Name",
    },
    {
      field: "workHours",
      headerName: "Monday",
      cellRenderer: (params) => formatTime(params.value[0]),
    },
    {
      field: "workHours",
      headerName: "Tuesday",
      cellRenderer: (params) => formatTime(params.value[1]),
    },
    {
      field: "workHours",
      headerName: "Wednesday",
      cellRenderer: (params) => formatTime(params.value[2]),
    },
    {
      field: "workHours",
      headerName: "Thursday",
      cellRenderer: (params) => formatTime(params.value[3]),
    },
    {
      field: "workHours",
      headerName: "Friday",
      cellRenderer: (params) => formatTime(params.value[4]),
    },
    {
      field: "workHours",
      headerName: "Saturday",
      cellRenderer: (params) => formatTime(params.value[5]),
    },
    {
      field: "workHours",
      headerName: "Sunday",
      cellRenderer: (params) => formatTime(params.value[6]),
    },
    {
      field: "totalHours",
      headerName: "Total",
      cellRenderer: (params) => formatTime(params.data.totalHours),
    },
  ];

  const clearForm = () => {
    setSelectedUser(null);
    setFilters(null);
    setEndDate(null);
    setStartDate(null);
  };

  const onUserSelection = (e) => {
    setSelectedUser(e);
    setOpenSelection(false);
    setFilters((prev) => ({ ...prev, userId: e.userId }));
  };

  const onStartDateChange = (date) => {
    setStartDate(date);
    setFilters((prev) => ({ ...prev, startDate: fixTimezoneOffset(date) }));
  };

  const onEndDateChange = (date) => {
    setEndDate(date);
    setFilters((prev) => ({ ...prev, endDate: fixTimezoneOffset(date) }));
  };

  const isMonday = (date) => {
    const day = new Date(date).getDay();
    return day === 1;
  };
  const isSunday = (date) => {
    const day = new Date(date).getDay();
    return day === 0;
  };

  return (
    <>
      <div className="grid-page">
        <div className="page-title page-title-editable">
          <p>Timesheet</p>
          <div>
            {/* <button className="import-btn" type="button" onClick={exportToExcel} disabled={disabledExportBtn || dataGrid?.length === 0}>
                            <img src={exportIcon} className="me-2" alt="" />
                            Export to Excel
                        </button> */}
          </div>
        </div>
        <div className="page-content-wrapper">
          <div className="grid-container has-filters">
            <div className="filters">
              <div className="d-flex mb-4">
                {userProfile?.data?.isAdmin && (
                  <div className="align-items-center d-flex">
                    <div className="form-group me-3">
                      <label>Employee</label>
                      <FormProvider {...methods}>
                        <Lookup
                          onButtonClicked={() => setOpenSelection(true)}
                          inputName="userId"
                          initialData={userAccounts?.data?.map((item) => ({
                            ...item,
                            id: item.userId,
                            name: item.employeeId,
                          }))}
                          onSelection={onUserSelection}
                          inputValue={selectedUser?.employeeId}
                        />
                      </FormProvider>
                    </div>
                  </div>
                )}
                <div>
                  <label className="me-2">Start Date</label> <br />
                  <DatePicker
                    onChange={(date) => onStartDateChange(date)}
                    selected={startDate}
                    className="form-control"
                    showYearDropdown
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={15}
                    scrollableYearDropdown
                    filterDate={isMonday}
                    maxDate={endDate}
                  />
                </div>
                <div className="mx-3">
                  <label className="me-2">End Date</label> <br />
                  <DatePicker
                    onChange={(date) => onEndDateChange(date)}
                    selected={endDate}
                    className="form-control"
                    showYearDropdown
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={15}
                    scrollableYearDropdown
                    filterDate={isSunday}
                    minDate={startDate}
                  />
                </div>
                <div className="mt-4">
                  <button
                    type="button"
                    className="btn btn-outline-primary custom-outline"
                    onClick={clearForm}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
            <div className="grid">
              <AgGrid
                columns={columns}
                data={data?.data?.entries}
                autoSize={true}
              />
            </div>
          </div>
        </div>
      </div>
      <SelectionModal
        modal={"Employee"}
        showModal={openSelection}
        setShowModal={setOpenSelection}
        data={userAccounts?.data}
        columns={userColumns}
        setRowClicked={onUserSelection}
      />
    </>
  );
};

export default Timesheet;
